import styled from 'styled-components'

import {
  METEOROLOGY_CONTROL_BOTTOM,
  METEOROLOGY_CONTROL_LOWERED_BOTTOM,
  METEOROLOGY_PLAYER_WIDTH
} from './MeteorologyControl.constants'

import { appZIndex } from '@/presentation/utils/zIndexMapper'

interface ContainerProps {
  show: boolean
  $horizontalOffset?: number
  $alignedToLeftPanel?: boolean
}

function getContainerBottom({ show, $alignedToLeftPanel }: ContainerProps): number {
  if (!show) return -60
  return $alignedToLeftPanel ? METEOROLOGY_CONTROL_LOWERED_BOTTOM : METEOROLOGY_CONTROL_BOTTOM
}

export const Container = styled.div<ContainerProps>`
  position: absolute;
  bottom: ${(props) => getContainerBottom(props)}px;
  left: calc(50% + ${({ $horizontalOffset = 0 }) => `${$horizontalOffset}px`});
  transform: translateX(-50%);
  z-index: ${appZIndex.METEOROLOGY_CONTROL};

  display: flex;
  flex-direction: column;
  /* Encostado no painel da esquerda, o horário fica sobre o início do player, longe do painel de ferramenta. */
  align-items: ${({ $alignedToLeftPanel }) => ($alignedToLeftPanel ? 'flex-start' : 'center')};
  justify-content: space-between;

  transition: bottom 0.4s;
`

interface InfoContainerProps {
  infoWarning: boolean
}

export const InfoContainer = styled.div<InfoContainerProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 36px;
  padding: 0 12px;
  border-radius: 13px;
  margin-bottom: 16px;
  gap: 8px;

  background-color: ${({ theme, infoWarning }) =>
    infoWarning ? `${theme.colors.error}cc` : `${theme.colors.secondaryD1}cc`};
`

export const InfoText = styled.p`
  ${({ theme }) => theme.fonts.infoMD}
  color: ${({ theme }) => theme.colors.neutralL5};
`

export const InfoButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
`

export const PlayerContainer = styled.div`
  width: ${METEOROLOGY_PLAYER_WIDTH}px;
  height: 58px;
  background-color: ${({ theme }) => `${theme.colors.secondaryD1}cc`};
  border-radius: 13px;

  padding: 0 10px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const SliderContainer = styled.div`
  flex: 1;
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 14px;
`
